import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from "@mui/material";
import { Form, Formik } from "formik";
import React from "react";
import * as Yup from "yup";
import TextfieldWrapper from "../../../../../../../Components/FormComponents/TextfieldWrapper";

const DisableQaQueueQuestion = ({ question, editQuestion }) => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button
        color={question.active ? "error" : "success"}
        onClick={handleClickOpen}>
        {question.active ? "Disable Q" : "Enable Q"}
      </Button>
      <Dialog maxWidth="md" fullWidth open={open} onClose={handleClose}>
        <DialogTitle>Disable Question</DialogTitle>

        <Formik
          initialValues={{
            id: question.id,
            question: question.question,
            group: question.group,
            auto_fail: question.auto_fail,
            call_back_request: question.call_back_request,
            compliance: question.compliance,
            product_knowledge: question.product_knowledge,
            professionalism: question.professionalism,
            sales_skills: question.sales_skills,
            tcf: question.tcf,
            updated_reason: "Update Question",
          }}
          validationSchema={Yup.object({
            question: Yup.string().required("Question is required"),
            group: Yup.string().required("Group is required"),
          })}
          onSubmit={(values) => {
            values.active = !question.active;

            editQuestion.mutate(values);

            setTimeout(() => {
              handleClose();
            }, 1000);
          }}>
          {() => (
            <Form>
              <DialogContent>
                <Stack spacing={2}>
                  <TextfieldWrapper
                    name="question"
                    label="Question"
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    required
                    disabled
                  />
                </Stack>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button
                  color={question.active ? "error" : "success"}
                  variant={question.active ? "contained" : "outlined"}
                  type="submit">
                  {question.active ? "Disable Q" : "Enable Q"}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
    </div>
  );
};

export default DisableQaQueueQuestion;
